export default [
  'AccountSettings',
  'contacts',
  null,
  'signupForm',
  'tasks',
]